<template>
    <div>
        <div
            v-if="
                !!personEntries &&
                    !!personEntries.data &&
                    personEntries.data.length === 0
            "
        >
            <b-alert show variant="info">No hay personas visitantes</b-alert>
        </div>

        <div v-else>
            <b-row v-if="!!personEntries">
                <b-col class="d-flex justify-content-center">
                    <app-paginator
                        v-bind="paginatorProps"
                        @change-page="changePage"
                    />
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" v-if="!!personEntries">
                    <app-person-departure-card
                        v-for="entry in personEntries.data"
                        :key="entry.id"
                        :entry="entry"
                        @departured="onDeparture"
                    ></app-person-departure-card>
                </b-col>
            </b-row>
            <b-row v-if="!!personEntries">
                <b-col class="d-flex justify-content-center">
                    <app-paginator
                        v-bind="paginatorProps"
                        @change-page="changePage"
                    />
                </b-col>
            </b-row>
        </div>
    </div>
</template>
<script>
import appPersonDepartureCard from './PersonDepartureCardV2'
import appPaginator from '../../../../UI/Controls/Paginator/PaginatorV2'
export default {
    components: {
        appPersonDepartureCard,
        appPaginator,
    },
    data: () => ({
        page: 1,
        personEntries: null,
        filters: {},
    }),
    computed: {
        paginatorProps() {
            if (!this.personEntries) return {}
            return _.pick(this.personEntries, [
                'current_page',
                'from',
                'to',
                'total',
                'per_page',
                'last_page',
            ])
        },
    },
    methods: {
        async loadPersonEntries(filters = {}) {
            if (!!Object.keys(filters).length) {
                const f = { ...this.filters, ...filters }
                this.filters = _.pickBy(f, (val, key) => !!val)
                this.page = 1
            }
            const params = {
                ...this.filters,
                venueId: this.accessPoint.venue_id,
                page: this.page,
                status: 'open',
            }
            const { data } = await repo.get('person-entries', params)
            this.personEntries = data
        },
        changePage(page) {
            this.page = page
            this.loadPersonEntries()
        },
        clearFilters() {
            this.page = 1
            this.filters = {}
            this.loadPersonEntries()
        },
        onDeparture(params) {
            this.loadPersonEntries()
            if (params.isPassenger) this.$emit('passenger-out')
        },
    },
    mounted() {
        this.loadPersonEntries()
    },
}
</script>
